module.exports = __webpack_public_path__ + "static/media/sad.11e1ea0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sad.png
// module id = 125
// module chunks = 0